import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { isNullOrUndefined } from 'util';

@Component
class BlockTanentTypesItem extends Vue {

  @Prop({ default: null, type: [String] })
  title: string;
  @Prop({ default: null, type: [Object] })
  customStyle: any;
  @Prop({ default: null, type: [String] })
  icon: string;
  @Prop({ default: null, type: [Number] })
  total: number;
  @Prop({ default: 0, type: [Number] })
  activeIndex: number;
  @Prop({ required: true, type: [Number] })
  index: number;


  get isActive(): boolean {
    return this.index === this.activeIndex;
  }
  get containerClass() {

    const classes: string[] = [];

    if (isNullOrUndefined(this.icon) || this.icon.length === 0) {
      classes.push('block-tenant-type--center')
    }

    if (this.isActive) {
      classes.push('secondary');
      classes.push('block-tenant-type--active')
    }
    return classes;
  }
  handleChangeType(event) {
    this.$emit('update:activeIndex', this.index);
    this.$emit('onSelect');
  }
}

export default BlockTanentTypesItem;



// WEBPACK FOOTER //
// ./src/containers/block/components/block-tenant-types-item/index.ts